import { EMPLOYMENT_TYPES } from 'cpool-constants';

import type { Schema_BeschaeftigungForm } from '~/features/leadDetails/schemas/employment.schema';

export const getEmploymentValues = (currentEmployment: Schema_BeschaeftigungForm) => {
    if (!currentEmployment) return null;

    switch (currentEmployment.beschaeftigungsart) {
        case EMPLOYMENT_TYPES.ANGESTELLTER:
            return currentEmployment.angestellter;
        case EMPLOYMENT_TYPES.ARBEITER:
            return currentEmployment.arbeiter;
        case EMPLOYMENT_TYPES.ARBEITSLOSER:
            return currentEmployment.arbeitsloser;
        case EMPLOYMENT_TYPES.AZUBI:
            return currentEmployment.azubi;
        case EMPLOYMENT_TYPES.BEAMTER:
            return currentEmployment.beamter;
        case EMPLOYMENT_TYPES.FREIBERUFLER:
            return currentEmployment.freiberufler;
        case EMPLOYMENT_TYPES.HAUSFRAU:
            return currentEmployment.hausfrau;
        case EMPLOYMENT_TYPES.RENTNER:
            return currentEmployment.rentner;
        case EMPLOYMENT_TYPES.SELBSTSTAENDIGER:
            return currentEmployment.selbststaendiger;
        case EMPLOYMENT_TYPES.STUDENT:
            return currentEmployment.student;
        default:
            console.error('Invalid employment type');
            return null;
    }
};
